module.exports = __webpack_public_path__ + "static/media/Fresh_Pack_Blue_10.94f60a89.png";